import { useRef, useState } from "react";
import { MirrorShotView } from "../views/mirrorShotView.jsx";
import { useParams } from "react-router-dom";
import { updateProgressReduxCB } from "../util/helpersFunction.js";
import locationInfo from "../data/locationInfo.json";
import images from "../images/images.js";
import ChatApi from "../util/chatApi.js";

function MirrorShot() {
  const quest = "mirrorShot";
  const { id, mode } = useParams();
  const drawingKey = `drawing_${id}`;
  const pictureKey = `picture_${id}`;
  const location = locationInfo[id];
  const title = location?.title;

  const videoRef = useRef(null);
  const streamRef = useRef(null);
  const usingCameraRef = useRef(false);

  const [currentStep, setCurrentStep] = useState(3);
  const [captured, setCaptured] = useState(false);
  const [showCameraButton, setShowCameraButton] = useState(true);
  const [showNextButtons, setShowNextButtons] = useState(false);
  const [capturedImageSrc, setCapturedImageSrc] = useState(null);

  if (!location) {
    return <div>Location not found</div>;
  }

  const handleNextBtnACB = async (status) => {
    try {
      updateProgressReduxCB(id, mode, status, quest);
      window.location.hash = `#/questComplete/${id}/${mode}/${quest}`;
    } catch (error) {
      console.error("Error updating progress:", error);
    }
  };

  const handleCameraClickACB = async () => {
    try {
      if (!usingCameraRef.current) {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: "environment" },
        });
        streamRef.current = stream;
        videoRef.current.srcObject = stream;
        await videoRef.current.play();
        usingCameraRef.current = true;
      } else {
        const video = videoRef.current;
        const canvas = document.createElement("canvas");
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(video, 0, 0);
        const dataUrl = canvas.toDataURL("image/jpeg");

        setCapturedImageSrc(dataUrl);
        setCaptured(true);
        setShowCameraButton(false);
        setShowNextButtons(true);
        setCurrentStep(4);

        streamRef.current.getTracks().forEach((track) => track.stop());
        usingCameraRef.current = false;
      
      }
    } catch (error) {
      console.error("Camera error:", error);
      alert("Could not access camera");
    }
  };

  return (
    <MirrorShotView
      drawingKey={drawingKey}
      pictureKey={pictureKey}
      onComplete={handleNextBtnACB}
      images={images}
      mode={mode}
      title={title}
      currentStep={currentStep}
      captured={captured}
      showCameraButton={showCameraButton}
      showNextButtons={showNextButtons}
      capturedImageSrc={capturedImageSrc}
      onCameraClick={handleCameraClickACB}
      videoRef={videoRef}
    />
  );
}

export { MirrorShot };
